import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/leader-crown-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1c3ba8ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-pathway"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 text-center" }
const _hoisted_4 = {
  class: "choose-pathway",
  "data-test": "choose-pathway-title"
}
const _hoisted_5 = {
  key: 0,
  class: "row pathway-tiles",
  "data-test": "pathway-grid"
}
const _hoisted_6 = {
  key: 1,
  class: "row pathway-carousel expanded-tiles"
}
const _hoisted_7 = {
  key: 2,
  class: "team-member-message",
  "data-test": "team-member-message"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Only your Team Lead can initiate an Outcome and Pathway for your team. Let them know which one you'd like to pick! ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "admin-question" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Not sure who your Team Lead is? ")
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "team lead icon"
  })
], -1))
const _hoisted_10 = ["href"]

import { inject, computed, ref, Ref, onMounted } from "vue";
import { Carousel, Slide, Btn } from "uiv";
import { useRoute } from "vue-router";
import PathwayTile from "./pathway-tile.vue";
import { CmsPathwayData, CmsPathwaysRelationship } from "../../services/cms/cms-type-definitions";
import { Analytics } from "../../services/analytics/analytics";
import cms from "../../services/cms/cms";
import { csContext } from "../../services/cs-context";
import axios from 'axios';

export interface PathwayTileData {
  pathwayId: string;
  pathwayUid: string;
  data: Partial<CmsPathwayData>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'select-team-pathway',
  props: {
    isTeamLeaderOrOrgAdmin: { type: Boolean },
    teamId: {},
    orgId: {}
  },
  emits: ["displayNextButton"],
  setup(__props: any, { emit: __emit }) {

const teamPathways = inject("teamPathways") as Ref<CmsPathwaysRelationship[]>;

const props = __props;

const emit = __emit;

const isExpandedView = ref<boolean>(false);

const activePathway = ref<PathwayTileData | null>(null);

const carouselPathways = ref<PathwayTileData[] | null>(null);

const controls = ref(true);

const route = useRoute();

const isAccreditedUser = computed(() => route.query.asaccredited === 'true');

const isTeamLeader = computed(() => {
  return props.isTeamLeaderOrOrgAdmin;
});

const isOrgAdmin = computed(() => {
  return props.isTeamLeaderOrOrgAdmin;
});

const handleDisplayControls = (pathways: PathwayTileData[]): void => {
  controls.value = pathways.length > 1;
};

const mapToData = (p: CmsPathwaysRelationship): PathwayTileData => {
  console.log('Mapping pathway:', p);
  return {
    pathwayUid: p.pathway.uid,
    pathwayId: p.pathway.id,
    data: p.pathway.data ?? {},
  };
};

const preparePathways = (): PathwayTileData[] => {
  console.log('Preparing pathways from:', teamPathways.value);
  return teamPathways.value.map((p) => mapToData(p));
};

const pathways = computed(() => {
  const preparedPathways = preparePathways();
  console.log('Prepared pathways:', preparedPathways);
  if (isExpandedView.value && carouselPathways.value) {
    handleDisplayControls(carouselPathways.value);
    return carouselPathways.value;
  }
  return preparedPathways;
});

const headerText = computed(() => {
  if (isTeamLeader.value || isOrgAdmin.value || isAccreditedUser.value) {
    return "Choose a pathway";
  }
  return "Browse pathways";
});

const teamId = computed(() => route.params.id);

const currentIndex = computed(() => {
  const pathwayTitle = activePathway.value?.data.title;
  const preparedPathways = preparePathways();
  return preparedPathways.findIndex((pathway) => {
    return pathway.data.title === pathwayTitle;
  });
});

const getCarouselOrder = (): void => {
  const pathwayIndex = currentIndex.value;
  const preparedPathways = preparePathways();
  const firstSection = preparedPathways.slice(pathwayIndex);
  const secondSection = preparedPathways.slice(0, pathwayIndex);
  carouselPathways.value = firstSection.concat(secondSection);
};

const toggleExpandedView = ({
  pathway,
  isOpen,
}: {
  pathway: PathwayTileData;
  isOpen: boolean;
}): void => {
  isExpandedView.value = isOpen;
  activePathway.value = pathway;
  if (isOpen) {
    getCarouselOrder();
  }
  Analytics.action("Clicked Team Pathway", "TeamPathwayActions", {
    outcomeTitle: cms.asText(activePathway.value?.data.goal_relationship?.data?.full_title),
    outcomeUid: activePathway.value?.data.goal_relationship?.uid,
    outcomeId: activePathway.value?.data.goal_relationship?.id,
    pathwayId: activePathway.value?.pathwayId,
    pathwayName: cms.asText(activePathway.value?.data?.title),
  });
  emit("displayNextButton", activePathway.value?.pathwayUid ?? "");
};

return (_ctx: any,_cache: any) => {
  return (_unref(teamPathways))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(headerText.value), 1)
          ])
        ]),
        (!isExpandedView.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathways.value, (pathway, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pathway-tile",
                  key: index
                }, [
                  _createVNode(PathwayTile, {
                    "data-test": `${pathway.pathwayUid}`,
                    pathway: pathway,
                    isExpandedView: isExpandedView.value,
                    onToggleExpandedView: toggleExpandedView
                  }, null, 8, ["data-test", "pathway", "isExpandedView"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(Carousel), {
                "icon-control-left": "btn btn-default-fab-chevron left",
                "icon-control-right": "btn btn-default-fab-chevron right",
                interval: 0,
                indicators: false,
                controls: controls.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathways.value, (pathway, index) => {
                    return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(PathwayTile, {
                          "data-test": `${pathway.pathwayUid}-expanded`,
                          pathway: pathway,
                          isExpandedView: isExpandedView.value,
                          onToggleExpandedView: toggleExpandedView
                        }, null, 8, ["data-test", "pathway", "isExpandedView"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["controls"])
            ])),
        (!isTeamLeader.value && !isAccreditedUser.value && isExpandedView.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("p", null, [
                _createTextVNode(" Check out the "),
                _createElementVNode("a", {
                  href: `/team/members/${teamId.value}`
                }, " Team members page ", 8, _hoisted_10),
                _createTextVNode(" on your Team dashboard and look for the person with a crown beside their name. ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})